import _defineProperty from "/builds/speachme/speachmeDesktop/speach-front/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.every.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.set.difference.v2.js";
import "core-js/modules/es.set.intersection.v2.js";
import "core-js/modules/es.set.is-disjoint-from.v2.js";
import "core-js/modules/es.set.is-subset-of.v2.js";
import "core-js/modules/es.set.is-superset-of.v2.js";
import "core-js/modules/es.set.symmetric-difference.v2.js";
import "core-js/modules/es.set.union.v2.js";
import "core-js/modules/esnext.map.get-or-insert.js";
import "core-js/modules/esnext.map.get-or-insert-computed.js";
import { __decorate } from "tslib";
import { Vue, Component, Prop, Watch } from 'vue-facing-decorator';
import WDialog from "@/components/wrappers/w-dialog.vue";
import IconButton from "@/components/buttons/IconButton.vue";
import StandardButton from "@/components/buttons/StandardButton.vue";
import Loader from "@/components/loader/Loader.vue";
import WInput from "@/components/form/w-input.vue";
import WSelect from "@/components/form/w-select.vue";
import Icon from "@/components/icon/Icon.vue";
import ConfirmDialog from "@/components/dialogs/ConfirmDialog.vue";
import SpeachHtmlTranslationDialog from "@/components/translation/SpeachHtmlTranslationDialog.vue";
import WPdfViewerDialog from "@/components/wrappers/w-pdf-viewer-dialog.vue";
import { WeetEventName } from "@/weet/weetEvent";
import axios from "axios";
import SpeachDiagramTranslationDialog from "@/components/translation/SpeachDiagramTranslationDialog.vue";
let SpeachManageTranslationsModal = class SpeachManageTranslationsModal extends Vue {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "speachId", void 0);
    _defineProperty(this, "visible", void 0);
    _defineProperty(this, "targetLanguages", void 0);
    _defineProperty(this, "originalLang", void 0);
    _defineProperty(this, "officialLanguages", void 0);
    _defineProperty(this, "transcriptEnabled", void 0);
    _defineProperty(this, "visionEnabled", void 0);
    _defineProperty(this, "loading", false);
    _defineProperty(this, "translatingMissing", false);
    _defineProperty(this, "cellTranslatingKey", null);
    _defineProperty(this, "overwriteDialogVisible", false);
    _defineProperty(this, "closing", false);
    _defineProperty(this, "inFlightSaves", new Set());
    /**
     * Maps every translatable speach key (without language prefix) to its parent group.
     * Used to render accordions per chapter / lesson / "speach metadata".
     */
    _defineProperty(this, "keyHierarchy", {});
    /** chapterId → videoId, used to route weet keys into the parent chapter's sub-accordion. */
    _defineProperty(this, "weetMappings", {});
    /** Per-parent expand/collapse state — ephemeral, reset every modal open. */
    _defineProperty(this, "expandedParents", {});
    _defineProperty(this, "allTranslations", {
      speach: {
        sourceMap: {},
        translations: {}
      },
      weet: {}
    });
    _defineProperty(this, "lastSaved", {
      speach: {},
      weet: {}
    });
    _defineProperty(this, "pendingOverwrite", null);
    // HTML-rich editor dialog state (chapter HTML, quiz info/correction, reussite success/fail)
    _defineProperty(this, "htmlEditDialogVisible", false);
    _defineProperty(this, "htmlEditContext", null);
    _defineProperty(this, "htmlEditSaving", false);
    // Diagram editor dialog
    _defineProperty(this, "diagramEditDialogVisible", false);
    _defineProperty(this, "diagramEditContext", null);
    _defineProperty(this, "diagramEditSaving", false);
    // PDF preview dialog state (for presentation.file.* rows)
    _defineProperty(this, "pdfPreviewVisible", false);
    _defineProperty(this, "pdfPreviewUrl", '');
    // Tracks which file cell is currently being hovered with a drag (for visual feedback)
    _defineProperty(this, "dragOverCell", null);
    // Weet subtitle editor dialog state
    _defineProperty(this, "subtitleDialogVisible", false);
    _defineProperty(this, "subtitleDialogUrl", '');
    _defineProperty(this, "openingSubtitleForChapter", null);
    // Filter state
    _defineProperty(this, "searchQuery", '');
    _defineProperty(this, "typeFilter", 'any');
    _defineProperty(this, "statusFilter", 'any');
    _defineProperty(this, "sortBy", 'last_added');
    _defineProperty(this, "selectedLanguageView", 'all');
  }
  get speachTitle() {
    const sourceMap = this.allTranslations.speach.sourceMap;
    const lang = this.originalLang ? this.originalLang.toLowerCase() : 'en';
    const targetKey = `${lang}.title`;
    if (sourceMap[targetKey]) return sourceMap[targetKey];
    const found = Object.keys(sourceMap).find(k => k.toLowerCase() === targetKey);
    return found ? sourceMap[found] : '';
  }
  get typeOptions() {
    return [{
      value: 'any',
      label: this.$t('speachTranslation.manage.types.any')
    }, {
      value: 'title',
      label: this.$t('speachTranslation.manage.types.title')
    }, {
      value: 'description',
      label: this.$t('speachTranslation.manage.types.description')
    }, {
      value: 'lesson',
      label: this.$t('speachTranslation.manage.types.lesson')
    }, {
      value: 'chapter',
      label: this.$t('speachTranslation.manage.types.chapter')
    }, {
      value: 'html',
      label: this.$t('speachTranslation.manage.types.html')
    }, {
      value: 'diagram',
      label: this.$t('speachTranslation.manage.types.diagram')
    }, {
      value: 'question',
      label: this.$t('speachTranslation.manage.types.question')
    }, {
      value: 'answer',
      label: this.$t('speachTranslation.manage.types.answer')
    }, {
      value: 'weet_chapter',
      label: this.$t('speachTranslation.manage.types.weet_chapter')
    }, {
      value: 'weet_annotation',
      label: this.$t('speachTranslation.manage.types.weet_annotation')
    }, {
      value: 'weet_annotation_title',
      label: this.$t('speachTranslation.manage.types.weet_annotation_title')
    }, {
      value: 'weet_annotation_description',
      label: this.$t('speachTranslation.manage.types.weet_annotation_description')
    }, {
      value: 'weet_annotation_button',
      label: this.$t('speachTranslation.manage.types.weet_annotation_button')
    }, {
      value: 'weet_slide_title',
      label: this.$t('speachTranslation.manage.types.weet_slide_title')
    }, {
      value: 'weet_slide_description',
      label: this.$t('speachTranslation.manage.types.weet_slide_description')
    }, {
      value: 'image',
      label: this.$t('speachTranslation.manage.types.image')
    }, {
      value: 'file',
      label: this.$t('speachTranslation.manage.types.file')
    }, {
      value: 'synchro',
      label: this.$t('speachTranslation.manage.types.synchro')
    }, {
      value: 'other',
      label: this.$t('speachTranslation.manage.types.other')
    }];
  }
  get statusOptions() {
    return [{
      value: 'any',
      label: this.$t('speachTranslation.manage.status.any')
    }, {
      value: 'complete',
      label: this.$t('speachTranslation.manage.status.complete')
    }, {
      value: 'incomplete',
      label: this.$t('speachTranslation.manage.status.incomplete')
    }];
  }
  get languageSelectorOptions() {
    const options = [{
      value: 'all',
      label: this.$t('speachTranslation.manage.languagesCount', this.targetLanguages.length)
    }];
    this.targetLanguages.forEach(lang => {
      options.push({
        value: lang,
        label: this.labelFor(lang)
      });
    });
    return options;
  }
  get filteredCount() {
    return Object.keys(this.groupedFilteredTranslations).length;
  }
  get hasMissingTranslations() {
    for (const key of Object.keys(this.allTranslations.speach.sourceMap)) {
      if (!this.targetLanguages.every(lang => {
        const tKey = this.getTranslationKey(lang, key);
        const v = this.allTranslations.speach.translations[tKey];
        return !!(v && v.trim().length > 0);
      })) return true;
    }
    for (const [videoId, bundle] of Object.entries(this.allTranslations.weet)) {
      for (const key of Object.keys(bundle.sourceMap)) {
        if (!this.targetLanguages.every(lang => {
          const tKey = this.getWeetTranslationKey(bundle.translations, lang, key);
          const v = bundle.translations[tKey];
          return !!(v && v.trim().length > 0);
        })) return true;
      }
    }
    return false;
  }
  isMissing(lang, groupKey, group) {
    if (!group.isWeet && group.type !== 'image' && group.type !== 'file' && group.type !== 'synchro') {
      const v = this.allTranslations.speach.translations[this.getTranslationKey(lang, groupKey)];
      return !v || v.trim().length === 0;
    } else if (group.isWeet && group.videoId) {
      const bundle = this.allTranslations.weet[group.videoId];
      if (!bundle) return true;
      const v = bundle.translations[this.getWeetTranslationKey(bundle.translations, lang, this.getOriginalWeetKey(groupKey))];
      return !v || v.trim().length === 0;
    }
    return false;
  }
  get groupedFilteredTranslations() {
    const filtered = {};
    const speachTr = this.allTranslations.speach.translations;
    // Speach keys
    Object.entries(this.allTranslations.speach.sourceMap).forEach(([key, value]) => {
      if (this.searchQuery && !value.toLowerCase().includes(this.searchQuery.toLowerCase()) && !key.toLowerCase().includes(this.searchQuery.toLowerCase())) return;
      const type = this.getKeyType(key, value);
      if (this.typeFilter !== 'any' && type !== this.typeFilter && !(this.typeFilter === 'other' && type === 'image')) return;
      if (this.statusFilter !== 'any') {
        const isComplete = this.targetLanguages.every(lang => {
          const tKey = this.getTranslationKey(lang, key);
          return speachTr[tKey] && speachTr[tKey].trim().length > 0;
        });
        if (this.statusFilter === 'complete' && !isComplete) return;
        if (this.statusFilter === 'incomplete' && isComplete) return;
      }
      filtered[key] = {
        sourceValue: value,
        type
      };
    });
    // Weet keys
    Object.entries(this.allTranslations.weet).forEach(([videoId, bundle]) => {
      Object.entries(bundle.sourceMap).forEach(([key, value]) => {
        if (this.searchQuery && !value.toLowerCase().includes(this.searchQuery.toLowerCase()) && !key.toLowerCase().includes(this.searchQuery.toLowerCase())) return;
        const type = this.getKeyType(`weet_${key}`, value);
        if (this.typeFilter !== 'any' && type !== this.typeFilter) return;
        if (this.statusFilter !== 'any') {
          const isComplete = this.targetLanguages.every(lang => {
            const tKey = this.getWeetTranslationKey(bundle.translations, lang, key);
            return bundle.translations[tKey] && bundle.translations[tKey].trim().length > 0;
          });
          if (this.statusFilter === 'complete' && !isComplete) return;
          if (this.statusFilter === 'incomplete' && isComplete) return;
        }
        const uniqueKey = `weet_${videoId}_${key}`;
        filtered[uniqueKey] = {
          sourceValue: value,
          type,
          isWeet: true,
          videoId
        };
      });
    });
    return filtered;
  }
  /**
   * Reshapes {@link groupedFilteredTranslations} into a list of accordions grouped by parent.
   * Each accordion holds the cards belonging to the same chapter / lesson / speach root,
   * preserving the natural iteration order of the source map.
   */
  get accordionsForRender() {
    /**
     * Two-level tree:
     *   - level-1 accordion (speach / lesson / weet) — speach is collapsible,
     *     lesson and weet are non-collapsible (decorative header only)
     *   - level-2 sub-accordion (chapter) — collapsible, indented, lives under its lesson
     *
     * Speach metadata (title, description) sit under "speach".
     * Weet keys all sit flat under "weet.<videoId>" (no chapter nesting).
     * Chapters of a lesson become sub-accordions of that lesson.
     */
    const accordions = new Map();
    const ensureLevel1 = parentKey => {
      if (!accordions.has(parentKey)) {
        accordions.set(parentKey, {
          parentKey,
          parentLabel: this.getParentLabel(parentKey),
          parentType: this.getParentType(parentKey),
          groups: {},
          subAccordions: new Map(),
          count: 0
        });
      }
      return accordions.get(parentKey);
    };
    const ensureChapterSub = (lessonAcc, chapterKey) => {
      if (!lessonAcc.subAccordions.has(chapterKey)) {
        lessonAcc.subAccordions.set(chapterKey, {
          parentKey: chapterKey,
          parentLabel: this.getParentLabel(chapterKey),
          parentType: 'chapter',
          groups: {},
          count: 0
        });
      }
      return lessonAcc.subAccordions.get(chapterKey);
    };
    // Reverse weetMappings (chapterId → videoId) to find which chapter contains a given weet.
    const videoIdToChapter = {};
    for (const [chapterId, videoId] of Object.entries(this.weetMappings || {})) {
      if (videoId) videoIdToChapter[videoId] = 'chapter.' + chapterId;
    }
    Object.entries(this.groupedFilteredTranslations).forEach(([groupKey, group]) => {
      if (group.isWeet && group.videoId) {
        // Route the weet group into the sub-accordion of the chapter it belongs to.
        const chapterKey = videoIdToChapter[group.videoId];
        if (chapterKey) {
          const lessonKey = this.keyHierarchy[chapterKey] || 'speach';
          const lessonAcc = ensureLevel1(lessonKey);
          const chapterAcc = ensureChapterSub(lessonAcc, chapterKey);
          chapterAcc.groups[groupKey] = group;
          chapterAcc.count++;
          return;
        }
        // Fallback: orphan weet (no matching chapter) — keep its own level-1 accordion.
        const acc = ensureLevel1('weet.' + group.videoId);
        acc.groups[groupKey] = group;
        acc.count++;
        return;
      }
      const unprefixed = this.stripLangPrefix(groupKey);
      // A "chapter.<id>" key is the chapter title itself — it belongs INSIDE the chapter's sub-accordion
      // (so collapsing the chapter also hides its title card).
      if (unprefixed.startsWith('chapter.')) {
        const chapterKey = unprefixed;
        const lessonKey = this.keyHierarchy[chapterKey] || 'speach';
        const lessonAcc = ensureLevel1(lessonKey);
        const chapterAcc = ensureChapterSub(lessonAcc, chapterKey);
        chapterAcc.groups[groupKey] = group;
        chapterAcc.count++;
        return;
      }
      const directParent = this.keyHierarchy[unprefixed] || 'speach';
      if (directParent.startsWith('chapter.')) {
        // Content of a chapter (html, presentation, questions, ...) → sub-accordion under the lesson.
        const lessonKey = this.keyHierarchy[directParent] || 'speach';
        const lessonAcc = ensureLevel1(lessonKey);
        const chapterAcc = ensureChapterSub(lessonAcc, directParent);
        chapterAcc.groups[groupKey] = group;
        chapterAcc.count++;
      } else {
        // Direct child of speach or a lesson (e.g. lesson title sits at the lesson's own level).
        const acc = ensureLevel1(directParent);
        acc.groups[groupKey] = group;
        acc.count++;
      }
    });
    // Compute completion stats (own groups + sub-chapters for lessons).
    const targets = this.targetLanguages || [];
    const statsForGroups = groups => {
      let total = 0,
        filled = 0;
      Object.entries(groups).forEach(([groupKey, group]) => {
        for (const lang of targets) {
          total++;
          if (!this.isMissing(lang, groupKey, group)) filled++;
        }
      });
      return {
        total,
        filled
      };
    };
    accordions.forEach(acc => {
      let total = 0,
        filled = 0;
      const own = statsForGroups(acc.groups);
      total += own.total;
      filled += own.filled;
      const subs = [];
      acc.subAccordions.forEach(sub => {
        const s = statsForGroups(sub.groups);
        sub.total = s.total;
        sub.filled = s.filled;
        sub.missing = Math.max(0, s.total - s.filled);
        sub.donePercent = s.total > 0 ? Math.round(s.filled / s.total * 100) : 100;
        total += s.total;
        filled += s.filled;
        subs.push(sub);
      });
      acc.subAccordions = subs; // convert Map → Array for the template
      acc.total = total;
      acc.filled = filled;
      acc.missing = Math.max(0, total - filled);
      acc.donePercent = total > 0 ? Math.round(filled / total * 100) : 100;
    });
    return Array.from(accordions.values());
  }
  stripLangPrefix(key) {
    const parts = key.split('.');
    if (parts.length > 1 && parts[0].length >= 2 && parts[0].length <= 5) {
      return parts.slice(1).join('.');
    }
    return key;
  }
  getParentLabel(parentKey) {
    if (parentKey === 'speach') return this.$t('speachTranslation.manage.parents.speach');
    if (parentKey.startsWith('weet.')) return this.$t('speachTranslation.manage.parents.weet');
    if (parentKey.startsWith('chapter.') || parentKey.startsWith('lesson.')) {
      // Resolve the friendly title from the source map (lang-prefixed)
      const sourceKey = (this.originalLang || '') + '.' + parentKey;
      const map = this.allTranslations.speach.sourceMap;
      const direct = map[sourceKey];
      if (direct) return this.stripHtmlPreview(direct);
      const match = Object.keys(map).find(k => k.toUpperCase() === sourceKey.toUpperCase());
      if (match) return this.stripHtmlPreview(map[match]);
      return parentKey.startsWith('lesson.') ? this.$t('speachTranslation.manage.parents.lesson') : this.$t('speachTranslation.manage.parents.chapter');
    }
    return parentKey;
  }
  getParentType(parentKey) {
    if (parentKey === 'speach') return 'speach';
    if (parentKey.startsWith('chapter.')) return 'chapter';
    if (parentKey.startsWith('lesson.')) return 'lesson';
    if (parentKey.startsWith('weet.')) return 'weet';
    return 'other';
  }
  /**
   * Sets the initial expand/collapse state per accordion: collapsed if 100% translated,
   * expanded otherwise. Called once after the data loads.
   */
  initExpandedParents() {
    const next = {};
    this.accordionsForRender.forEach(acc => {
      if (this.isParentCollapsible(acc.parentKey)) {
        next[acc.parentKey] = acc.donePercent < 100;
      }
      (acc.subAccordions || []).forEach(sub => {
        if (this.isParentCollapsible(sub.parentKey)) {
          next[sub.parentKey] = sub.donePercent < 100;
        }
      });
    });
    this.expandedParents = next;
  }
  isParentCollapsible(parentKey) {
    // Speach metadata, lessons, and chapter sub-accordions all fold/unfold.
    // Only weet headers stay decorative.
    return parentKey === 'speach' || parentKey.startsWith('lesson.') || parentKey.startsWith('chapter.');
  }
  isParentExpanded(parentKey) {
    if (!this.isParentCollapsible(parentKey)) return true;
    if (this.searchQuery || this.typeFilter !== 'any' || this.statusFilter !== 'any') return true;
    return this.expandedParents[parentKey] !== false;
  }
  toggleParent(parentKey) {
    if (!this.isParentCollapsible(parentKey)) return;
    this.expandedParents[parentKey] = !this.isParentExpanded(parentKey);
  }
  mounted() {
    if (this.visible) this.fetchData();
  }
  beforeUnmount() {
    // Belt & suspenders: if the parent closes the modal while the subtitle iframe is still open,
    // we'd otherwise leak the window 'message' listener and its captured component reference.
    if (this.subtitleDialogVisible) this.closeSubtitleDialog();
  }
  onVisibleChange(val) {
    if (val) {
      this.selectedLanguageView = 'all';
      this.fetchData();
    }
  }
  /**
   * Single unified fetch — speach + all weet bundles come from /data.
   */
  async fetchData() {
    this.loading = true;
    this.inFlightSaves = new Set();
    this.closing = false;
    try {
      const resp = await axios.get(`/api/v2/translations/${this.speachId}/data`);
      const data = resp.data || {};
      this.allTranslations = {
        speach: {
          sourceMap: data.speach && data.speach.sourceMap || {},
          translations: data.speach && data.speach.translations || {}
        },
        weet: data.weet || {}
      };
      this.keyHierarchy = data.keyHierarchy || {};
      this.weetMappings = data.weetMappings || {};
      // Default: collapsed when 100% done, expanded otherwise. Computed once on open;
      // the user remains free to toggle either way after that.
      this.expandedParents = {};
      this.$nextTick(() => this.initExpandedParents());
      // Build last-saved snapshots
      this.lastSaved = {
        speach: {
          ...this.allTranslations.speach.translations
        },
        weet: {}
      };
      for (const [videoId, bundle] of Object.entries(this.allTranslations.weet)) {
        this.lastSaved.weet[videoId] = {
          ...(bundle.translations || {})
        };
      }
    } catch (err) {
      console.error("Failed to fetch translation data", err);
    } finally {
      this.loading = false;
    }
  }
  labelFor(code) {
    const found = this.officialLanguages.find(l => l.value === code);
    return found ? found.label : code;
  }
  getTranslationKey(targetLang, sourceKey) {
    const parts = sourceKey.split('.');
    let suffix = sourceKey;
    if (parts.length > 1 && parts[0].length >= 2 && parts[0].length <= 5) {
      suffix = parts.slice(1).join('.');
    }
    const targetKey = targetLang.toUpperCase() + '.' + suffix;
    const map = this.allTranslations.speach.translations;
    const match = Object.keys(map).find(k => k.toUpperCase() === targetKey.toUpperCase());
    return match || targetKey;
  }
  getKeyType(key, value = '') {
    if (key.startsWith('weet_')) {
      if (key.includes('.annotationCard.title.')) return 'weet_annotation_title';
      if (key.includes('.annotationCard.description.')) return 'weet_annotation_description';
      if (key.includes('.annotationCard.button.')) return 'weet_annotation_button';
      if (key.includes('.annotationCard.image.')) return 'image';
      if (key.includes('.annotation') || key.includes('.annotationCard.')) return 'weet_annotation';
      if (key.includes('.slide.title.')) return 'weet_slide_title';
      if (key.includes('.slide.description.')) return 'weet_slide_description';
      return 'weet_chapter';
    }
    if (key.includes('.presentation.file.')) return 'file';
    if (key.includes('.synchro.file.')) return 'synchro';
    if (key.includes('.presentation.slideBlock.')) {
      const val = value.toLowerCase();
      if (val.includes('/photos/') || val.endsWith('.jpg') || val.endsWith('.png') || val.endsWith('.jpeg') || val.endsWith('.gif')) {
        return 'image';
      }
    }
    if (key.includes('.title')) return 'title';
    if (key.includes('.description')) return 'description';
    if (key.includes('.lesson.')) return 'lesson';
    if (key.includes('.chapter.')) return 'chapter';
    if (key.includes('.html.')) return 'html';
    if (key.includes('.diagram.')) return 'diagram';
    if (key.includes('.question.')) return 'question';
    if (key.includes('.answer.')) return 'answer';
    return 'other';
  }
  /**
   * Returns true for keys whose value is rich HTML — those go through the TinyMCE dialog
   * instead of a plain textarea. Covers chapter HTML, quiz info/correction, success/fail messages.
   */
  isRichKey(key) {
    if (!key) return false;
    if (key.includes('.html.')) return true;
    if (key.includes('.diagram.')) return true;
    if (key.includes('.question.info.')) return true;
    if (key.includes('.question.correction.')) return true;
    if (key.endsWith('.reussite.success')) return true;
    if (key.endsWith('.reussite.fail')) return true;
    return false;
  }
  /**
   * Strips HTML tags and truncates to ~80 chars for in-row preview.
   */
  stripHtmlPreview(html) {
    if (!html) return '';
    const text = String(html).replace(/<[^>]*>/g, ' ').replace(/&nbsp;/g, ' ').replace(/\s+/g, ' ').trim();
    return text.length > 80 ? text.substring(0, 80) + '…' : text;
  }
  getImageUrl(path, videoId) {
    if (!path) return '';
    if (path.startsWith('http')) return path;
    if (videoId) return `/api/v2/translations/weet/${videoId}/image?path=${encodeURIComponent(path)}`;
    const p = path.startsWith('/') ? path : '/' + path;
    return p;
  }
  getGroupLabel(key) {
    const type = this.getKeyType(key);
    const typeLabels = {
      title: this.$t('speachTranslation.manage.types.title'),
      description: this.$t('speachTranslation.manage.types.description'),
      lesson: this.$t('speachTranslation.manage.types.lesson'),
      chapter: this.$t('speachTranslation.manage.types.chapter'),
      html: this.$t('speachTranslation.manage.types.html'),
      diagram: this.$t('speachTranslation.manage.types.diagram'),
      question: this.$t('speachTranslation.manage.types.question'),
      answer: this.$t('speachTranslation.manage.types.answer'),
      weet: this.$t('speachTranslation.manage.types.weet'),
      weet_chapter: this.$t('speachTranslation.manage.types.weet_chapter'),
      weet_annotation: this.$t('speachTranslation.manage.types.weet_annotation'),
      weet_annotation_title: this.$t('speachTranslation.manage.types.weet_annotation_title'),
      weet_annotation_description: this.$t('speachTranslation.manage.types.weet_annotation_description'),
      weet_annotation_button: this.$t('speachTranslation.manage.types.weet_annotation_button'),
      weet_slide_title: this.$t('speachTranslation.manage.types.weet_slide_title'),
      weet_slide_description: this.$t('speachTranslation.manage.types.weet_slide_description'),
      image: this.$t('speachTranslation.manage.types.image'),
      file: this.$t('speachTranslation.manage.types.file'),
      synchro: this.$t('speachTranslation.manage.types.synchro'),
      other: this.$t('speachTranslation.manage.types.other')
    };
    return typeLabels[type] || this.$t('speachTranslation.manage.types.other');
  }
  getGroupIcon(key) {
    const type = this.getKeyType(key);
    const iconMap = {
      title: 'information-outline',
      description: 'text-box-outline',
      lesson: 'book-outline',
      chapter: 'file-document-outline',
      html: 'code-tags',
      question: 'help-circle-outline',
      answer: 'check-circle-outline',
      weet: 'video-outline',
      weet_chapter: 'format-title',
      weet_annotation: 'comment-text-outline',
      weet_annotation_title: 'format-title',
      weet_annotation_description: 'text-box-outline',
      weet_annotation_button: 'gesture-tap-button',
      weet_slide_title: 'format-title',
      weet_slide_description: 'text-box-outline',
      image: 'image-outline',
      file: 'file-pdf-outline',
      synchro: 'sync',
      other: 'information-outline'
    };
    return iconMap[type] || 'information-outline';
  }
  getOriginalWeetKey(uniqueKey) {
    const parts = uniqueKey.split('_');
    if (parts.length >= 3 && parts[0] === 'weet') {
      return parts.slice(2).join('_');
    }
    return uniqueKey;
  }
  getWeetTranslationKey(weetTranslations, targetLang, sourceKey) {
    const parts = sourceKey.split('.');
    let suffix = sourceKey;
    if (parts.length > 1 && (parts[0].length === 2 || parts[0].length === 5)) {
      suffix = parts.slice(1).join('.');
    }
    const targetKey = targetLang.toUpperCase() + "." + suffix;
    if (weetTranslations[targetKey]) return targetKey;
    const existingKeys = Object.keys(weetTranslations);
    const insensitive = existingKeys.find(k => k.toUpperCase() === targetKey.toUpperCase());
    if (insensitive) return insensitive;
    const truncated = existingKeys.find(k => {
      if (!k.toUpperCase().startsWith(targetLang.toUpperCase() + ".")) return false;
      const tp = targetKey.split('.');
      const kp = k.split('.');
      if (tp.length !== kp.length) return false;
      for (let i = 0; i < tp.length - 1; i++) {
        if (tp[i].toUpperCase() !== kp[i].toUpperCase()) return false;
      }
      const idPart = kp[kp.length - 1];
      return idPart.length === 15 && targetKey.includes(idPart);
    });
    return truncated || targetKey;
  }
  getVisibleLanguages() {
    if (this.selectedLanguageView === 'all') return this.targetLanguages;
    return [this.selectedLanguageView];
  }
  onLanguageViewChange() {}
  applyFilters() {}
  triggerUpload(lang, groupKey) {
    const el = document.getElementById(`file-${lang}-${groupKey}`);
    if (el) el.click();
  }
  async onFileChange(event, lang, groupKey, group) {
    const file = event.target.files[0];
    if (!file) return;
    const formData = new FormData();
    formData.append('file', file);
    try {
      let endpoint;
      if (group.isWeet && group.videoId) {
        endpoint = `/api/v2/translations/weet/${group.videoId}/upload-image`;
      } else if (group.type === 'image') {
        endpoint = `/api/v2/translations/${this.speachId}/upload-image`;
      } else {
        endpoint = `/api/v2/translations/${this.speachId}/upload-file`;
      }
      const resp = await axios.post(endpoint, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
      if (resp.data && resp.data.path) {
        if (!group.isWeet) {
          const tKey = this.getTranslationKey(lang, groupKey);
          this.allTranslations.speach.translations[tKey] = resp.data.path;
          // Persist immediately
          await this.persistKey(lang, groupKey, false);
        } else if (group.videoId && this.allTranslations.weet[group.videoId]) {
          const bundle = this.allTranslations.weet[group.videoId];
          const tKey = this.getWeetTranslationKey(bundle.translations, lang, this.getOriginalWeetKey(groupKey));
          bundle.translations[tKey] = resp.data.path;
          await this.persistKey(lang, groupKey, true, group.videoId);
        }
        this.$forceUpdate();
      }
    } catch (e) {
      console.error("Failed to upload translated image", e);
    }
  }
  onCellAiClick(lang, groupKey, group) {
    if (group && group.isWeet) {
      const bundle = this.allTranslations.weet[group.videoId];
      if (!bundle) return;
      const tKey = this.getWeetTranslationKey(bundle.translations, lang, this.getOriginalWeetKey(groupKey));
      const existing = bundle.translations[tKey];
      if (existing && String(existing).trim().length > 0) {
        this.pendingOverwrite = {
          lang,
          groupKey,
          isWeet: true,
          videoId: group.videoId
        };
        this.overwriteDialogVisible = true;
        return;
      }
      this.translateWeetCell(lang, groupKey, group.videoId);
      return;
    }
    const existing = this.allTranslations.speach.translations[this.getTranslationKey(lang, groupKey)];
    if (existing && String(existing).trim().length > 0) {
      this.pendingOverwrite = {
        lang,
        groupKey
      };
      this.overwriteDialogVisible = true;
      return;
    }
    this.translateCell(lang, groupKey);
  }
  cancelOverwrite() {
    this.overwriteDialogVisible = false;
    this.pendingOverwrite = null;
  }
  confirmOverwrite() {
    const pending = this.pendingOverwrite;
    this.overwriteDialogVisible = false;
    this.pendingOverwrite = null;
    if (!pending) return;
    if (pending.isWeet && pending.videoId) {
      this.translateWeetCell(pending.lang, pending.groupKey, pending.videoId);
    } else {
      this.translateCell(pending.lang, pending.groupKey, true);
    }
  }
  /**
   * Synchronous per-cell AI translate for a weet annotation/card/chapter/slide.
   * Calls our /translate-cell endpoint (which proxies transcript-back's sync /translate),
   * then persists via the regular save path so caches invalidate the same way as a manual edit.
   */
  async translateWeetCell(lang, groupKey, videoId) {
    if (this.cellTranslatingKey !== null) return;
    const bundle = this.allTranslations.weet[videoId];
    if (!bundle) return;
    const originalKey = this.getOriginalWeetKey(groupKey);
    const sourceText = bundle.sourceMap ? bundle.sourceMap[originalKey] : '';
    if (!sourceText) return;
    const trackingKey = `weet:${videoId}:${lang}:${groupKey}`;
    this.cellTranslatingKey = trackingKey;
    try {
      const resp = await axios.post(`/api/v2/translations/${this.speachId}/translate-cell`, {
        sourceLanguage: this.originalLang,
        targetLanguage: lang.toUpperCase(),
        text: sourceText
      });
      const translation = resp.data && resp.data.translation;
      if (typeof translation === 'string') {
        const tKey = this.getWeetTranslationKey(bundle.translations, lang, originalKey);
        bundle.translations[tKey] = translation;
        this.$forceUpdate();
        await this.onCellBlur(lang, groupKey, true, videoId);
      }
    } catch (err) {
      console.error("Failed to AI-translate weet cell", err);
    } finally {
      this.cellTranslatingKey = null;
    }
  }
  async translateCell(lang, groupKey, force = false) {
    if (this.cellTranslatingKey !== null) return;
    const tKey = this.getTranslationKey(lang, groupKey);
    this.cellTranslatingKey = tKey;
    try {
      const startResp = await axios.post(`/api/v2/translations/${this.speachId}/auto-translate`, {
        originalLanguage: this.originalLang,
        languages: [lang.toUpperCase()],
        keys: [groupKey]
      });
      const jobID = startResp.data;
      if (jobID) await this.pollJob(jobID);
      await this.refreshTranslationsFromServer(force ? [tKey] : []);
    } catch (err) {
      console.error("Failed to AI-translate single cell", err);
    } finally {
      this.cellTranslatingKey = null;
    }
  }
  async translateMissingForView() {
    if (this.translatingMissing) return;
    const langs = this.getVisibleLanguages();
    // --- SPEACH: collect missing keys per lang ---
    const requestsByLang = {};
    for (const lang of langs) {
      const missingKeys = [];
      for (const sourceKey of Object.keys(this.allTranslations.speach.sourceMap)) {
        const tKey = this.getTranslationKey(lang, sourceKey);
        const v = this.allTranslations.speach.translations[tKey];
        if (!v || String(v).trim().length === 0) missingKeys.push(sourceKey);
      }
      if (missingKeys.length > 0) requestsByLang[lang] = missingKeys;
    }
    const weetMissingByLang = {};
    for (const lang of langs) {
      const items = [];
      for (const [videoId, bundle] of Object.entries(this.allTranslations.weet)) {
        if (!bundle || !bundle.sourceMap) continue;
        for (const sourceKey of Object.keys(bundle.sourceMap)) {
          const tKey = this.getWeetTranslationKey(bundle.translations, lang, sourceKey);
          const v = bundle.translations[tKey];
          if (!v || String(v).trim().length === 0) {
            const sourceText = bundle.sourceMap[sourceKey];
            if (sourceText && String(sourceText).trim().length > 0) {
              items.push({
                videoId,
                originalKey: sourceKey,
                sourceText
              });
            }
          }
        }
      }
      if (items.length > 0) weetMissingByLang[lang] = items;
    }
    if (Object.keys(requestsByLang).length === 0 && Object.keys(weetMissingByLang).length === 0) return;
    this.translatingMissing = true;
    try {
      // Speach (inchangé): mode "keys" sur /auto-translate.
      for (const [lang, keys] of Object.entries(requestsByLang)) {
        const startResp = await axios.post(`/api/v2/translations/${this.speachId}/auto-translate`, {
          originalLanguage: this.originalLang,
          languages: [lang],
          keys
        });
        const jobID = startResp.data;
        if (jobID) await this.pollJob(jobID);
      }
      // Weet: traduction sync par cellule, en parallèle par (lang, videoId).
      const touchedVideoIds = new Set();
      for (const [lang, items] of Object.entries(weetMissingByLang)) {
        const upperLang = lang.toUpperCase();
        const byVideo = {};
        for (const item of items) {
          if (!byVideo[item.videoId]) byVideo[item.videoId] = [];
          byVideo[item.videoId].push(item);
        }
        for (const [videoId, videoItems] of Object.entries(byVideo)) {
          const bundle = this.allTranslations.weet[videoId];
          if (!bundle) continue;
          const results = await Promise.all(videoItems.map(item => axios.post(`/api/v2/translations/${this.speachId}/translate-cell`, {
            sourceLanguage: this.originalLang,
            targetLanguage: upperLang,
            text: item.sourceText
          }).then(resp => ({
            item,
            translation: resp.data && resp.data.translation
          })).catch(err => {
            console.error("Failed to translate weet cell", err);
            return null;
          })));
          for (const result of results) {
            if (!result || typeof result.translation !== 'string') continue;
            const tKey = this.getWeetTranslationKey(bundle.translations, lang, result.item.originalKey);
            bundle.translations[tKey] = result.translation;
          }
          touchedVideoIds.add(videoId);
        }
      }
      // Persister une fois par videoId touché (full bundle → speacher_back merge côté store).
      for (const videoId of touchedVideoIds) {
        const bundle = this.allTranslations.weet[videoId];
        if (!bundle) continue;
        await axios.post(`/api/v2/translations/${this.speachId}/content`, {
          weet: {
            [videoId]: bundle.translations
          }
        });
      }
      this.$forceUpdate();
      await this.refreshTranslationsFromServer();
    } catch (err) {
      console.error("Failed to AI-translate missing keys", err);
    } finally {
      this.translatingMissing = false;
    }
  }
  async pollJob(jobID) {
    const maxAttempts = 60;
    for (let i = 0; i < maxAttempts; i++) {
      const resp = await axios.get(`/api/v2/translations/job/${jobID}`);
      if (resp.data === "OK") return;
      if (resp.data === "ERROR") throw new Error("Translation job failed");
      await new Promise(r => setTimeout(r, 2000));
    }
    throw new Error("Translation job timed out");
  }
  /**
   * Re-fetch /data and merge: server values win for forceKeys and for keys empty locally.
   */
  async refreshTranslationsFromServer(forceKeys = []) {
    const resp = await axios.get(`/api/v2/translations/${this.speachId}/data`);
    const data = resp.data || {};
    const incomingSpeach = data.speach && data.speach.translations || {};
    const incomingWeet = data.weet || {};
    const forced = new Set(forceKeys);
    const localSpeach = this.allTranslations.speach.translations;
    for (const [k, v] of Object.entries(incomingSpeach)) {
      if (forced.has(k)) {
        localSpeach[k] = v;
      } else if (localSpeach[k] === undefined || typeof localSpeach[k] === 'string' && localSpeach[k].trim() === '') {
        localSpeach[k] = v;
      }
    }
    for (const [videoId, bundle] of Object.entries(incomingWeet)) {
      const incomingTr = bundle.translations || {};
      if (!this.allTranslations.weet[videoId]) {
        this.allTranslations.weet[videoId] = {
          sourceMap: bundle.sourceMap || {},
          translations: {}
        };
      }
      const localTr = this.allTranslations.weet[videoId].translations;
      for (const [k, v] of Object.entries(incomingTr)) {
        if (!localTr[k] || typeof localTr[k] === 'string' && localTr[k].trim() === '') {
          localTr[k] = v;
        }
      }
    }
    this.$forceUpdate();
  }
  /**
   * Unified auto-save on textarea blur — both speach and weet go through the same /content endpoint
   * with a unified body shape: { speach: {...} } or { weet: { [videoId]: {...} } }.
   */
  async onCellBlur(lang, groupKey, isWeet, videoId) {
    await this.persistKey(lang, groupKey, isWeet, videoId);
  }
  openRichEditor(lang, groupKey, group) {
    if (groupKey.includes('.diagram.')) {
      this.openDiagramEditor(lang, groupKey, group);
    } else {
      this.openHtmlEditor(lang, groupKey, group);
    }
  }
  // ------------ Rich HTML editor dialog ------------
  openHtmlEditor(lang, groupKey, group) {
    this.htmlEditContext = {
      lang,
      groupKey,
      tKey: this.getTranslationKey(lang, groupKey),
      sourceValue: group ? group.sourceValue || '' : ''
    };
    this.htmlEditDialogVisible = true;
  }
  closeHtmlEditor() {
    this.htmlEditDialogVisible = false;
    this.htmlEditContext = null;
  }
  closeDiagramEditor() {
    this.diagramEditDialogVisible = false;
    this.diagramEditContext = null;
  }
  async saveHtmlEditor(newHtml) {
    if (!this.htmlEditContext) return;
    const {
      lang,
      groupKey,
      tKey
    } = this.htmlEditContext;
    this.htmlEditSaving = true;
    try {
      this.allTranslations.speach.translations[tKey] = newHtml || '';
      await this.persistKey(lang, groupKey, false);
    } finally {
      this.htmlEditSaving = false;
      this.closeHtmlEditor();
    }
  }
  async saveDiagramEditor(newD2Code) {
    if (!this.diagramEditContext) return;
    const {
      lang,
      groupKey,
      tKey
    } = this.diagramEditContext;
    this.diagramEditSaving = true;
    try {
      this.allTranslations.speach.translations[tKey] = newD2Code || '';
      await this.persistKey(lang, groupKey, false);
    } finally {
      this.diagramEditSaving = false;
      this.closeDiagramEditor();
    }
  }
  labelForLanguage(code) {
    return this.labelFor(code);
  }
  // ------------ PDF viewer dialog ------------
  openPdfPreview(url) {
    if (!url) return;
    this.pdfPreviewUrl = url;
    this.pdfPreviewVisible = true;
  }
  closePdfPreview() {
    this.pdfPreviewVisible = false;
    this.pdfPreviewUrl = '';
  }
  // ------------ Weet subtitle editor ------------
  get transcriptEnabledBoolean() {
    return this.transcriptEnabled === 'true';
  }
  // ------------ Diagram editor dialog ------------
  openDiagramEditor(lang, groupKey, group) {
    this.diagramEditContext = {
      lang,
      groupKey,
      tKey: this.getTranslationKey(lang, groupKey),
      sourceValue: group ? group.sourceValue || '' : ''
    };
    this.diagramEditDialogVisible = true;
  }
  /**
   * True for chapter sub-accordions whose chapter holds a weet — i.e. it makes sense to
   * jump into the Weet recorder's SUBTITLE mode. Hidden when the boutique has TRANSCRIPT_ENABLED = false.
   */
  canManageSubtitlesForChapter(parentKey) {
    if (!this.transcriptEnabledBoolean) return false;
    if (!parentKey || !parentKey.startsWith('chapter.')) return false;
    const chapterId = parentKey.substring('chapter.'.length);
    return !!(this.weetMappings && this.weetMappings[chapterId]);
  }
  async openSubtitleDialog(parentKey) {
    if (this.openingSubtitleForChapter !== null) return;
    if (!this.canManageSubtitlesForChapter(parentKey)) return;
    const chapterId = parentKey.substring('chapter.'.length);
    this.openingSubtitleForChapter = parentKey;
    try {
      const resp = await axios.get(`/api/v2/recorder/getUrlEditingForChapter/${encodeURIComponent(chapterId)}?mode=SUBTITLE`);
      const url = typeof resp.data === 'string' ? resp.data : '';
      if (!url) return;
      this.subtitleDialogUrl = url;
      this.subtitleDialogVisible = true;
      window.addEventListener('message', this.onSubtitleWeetMessage);
    } catch (err) {
      console.error("Failed to open subtitle editor for chapter", err);
    } finally {
      this.openingSubtitleForChapter = null;
    }
  }
  closeSubtitleDialog() {
    window.removeEventListener('message', this.onSubtitleWeetMessage);
    this.subtitleDialogVisible = false;
    this.subtitleDialogUrl = '';
  }
  /**
   * Closes the iframe dialog when the Weet recorder signals it is done (SEND_WEET_ID).
   * We intentionally don't refresh translation data: subtitles are stored as a separate
   * track and don't change the annotation/slide sourceMap shown in this modal.
   */
  onSubtitleWeetMessage(event) {
    const data = event && event.data;
    if (!data || typeof data !== 'object') return;
    // SEND_WEET_ID = end of edition. SILENTLY_SEND_WEET_ID is just an early ID broadcast
    // sent while still editing — do NOT close on it.
    if (data.name === WeetEventName.SEND_WEET_ID) {
      this.closeSubtitleDialog();
    }
  }
  // ------------ Drag & drop file upload ------------
  onFileDragEnter(lang, groupKey) {
    this.dragOverCell = `${lang}|${groupKey}`;
  }
  onFileDragLeave() {
    this.dragOverCell = null;
  }
  async onFileDrop(event, lang, groupKey, group) {
    this.dragOverCell = null;
    if (!event.dataTransfer || !event.dataTransfer.files || event.dataTransfer.files.length === 0) return;
    const file = event.dataTransfer.files[0];
    // Reuse the existing upload pipeline by mimicking a regular <input type=file> change event.
    await this.onFileChange({
      target: {
        files: [file]
      }
    }, lang, groupKey, group);
  }
  isDragOverCell(lang, groupKey) {
    return this.dragOverCell === `${lang}|${groupKey}`;
  }
  async persistKey(lang, groupKey, isWeet, videoId) {
    if (!isWeet) {
      const tKey = this.getTranslationKey(lang, groupKey);
      const current = this.allTranslations.speach.translations[tKey] ?? '';
      const lastSaved = this.lastSaved.speach[tKey] ?? '';
      if (current === lastSaved) return;
      if (this.inFlightSaves.has(tKey)) return;
      this.inFlightSaves.add(tKey);
      this.$forceUpdate();
      try {
        await axios.post(`/api/v2/translations/${this.speachId}/content`, {
          speach: {
            [tKey]: current
          }
        });
        this.lastSaved.speach[tKey] = current;
      } catch (err) {
        console.error("Failed to auto-save speach translation", err);
      } finally {
        this.inFlightSaves.delete(tKey);
        this.$forceUpdate();
      }
    } else {
      if (!videoId) return;
      const bundle = this.allTranslations.weet[videoId];
      if (!bundle) return;
      const tKey = this.getWeetTranslationKey(bundle.translations, lang, this.getOriginalWeetKey(groupKey));
      const flightKey = `weet:${videoId}:${tKey}`;
      const current = bundle.translations[tKey] ?? '';
      const lastSaved = this.lastSaved.weet[videoId]?.[tKey] ?? '';
      if (current === lastSaved) return;
      if (this.inFlightSaves.has(flightKey)) return;
      this.inFlightSaves.add(flightKey);
      this.$forceUpdate();
      try {
        // For weet, speacher-back currently overwrites — so we send the full bundle for this videoId.
        await axios.post(`/api/v2/translations/${this.speachId}/content`, {
          weet: {
            [videoId]: bundle.translations
          }
        });
        if (!this.lastSaved.weet[videoId]) this.lastSaved.weet[videoId] = {};
        this.lastSaved.weet[videoId][tKey] = current;
      } catch (err) {
        console.error(`Failed to auto-save weet translation for ${videoId}`, err);
      } finally {
        this.inFlightSaves.delete(flightKey);
        this.$forceUpdate();
      }
    }
  }
  async onCloseClick() {
    if (this.closing) return;
    this.closing = true;
    try {
      while (this.inFlightSaves.size > 0) {
        await new Promise(r => setTimeout(r, 100));
      }
      this.$emit('saved');
      this.$emit('close');
    } finally {
      this.closing = false;
    }
  }
};
__decorate([Prop({
  required: true
})], SpeachManageTranslationsModal.prototype, "speachId", void 0);
__decorate([Prop({
  default: false
})], SpeachManageTranslationsModal.prototype, "visible", void 0);
__decorate([Prop({
  default: () => []
})], SpeachManageTranslationsModal.prototype, "targetLanguages", void 0);
__decorate([Prop({
  default: 'EN'
})], SpeachManageTranslationsModal.prototype, "originalLang", void 0);
__decorate([Prop({
  default: () => []
})], SpeachManageTranslationsModal.prototype, "officialLanguages", void 0);
__decorate([Prop({
  default: 'false'
})], SpeachManageTranslationsModal.prototype, "transcriptEnabled", void 0);
__decorate([Prop({
  default: false
})], SpeachManageTranslationsModal.prototype, "visionEnabled", void 0);
__decorate([Watch('visible')], SpeachManageTranslationsModal.prototype, "onVisibleChange", null);
SpeachManageTranslationsModal = __decorate([Component({
  components: {
    SpeachDiagramTranslationDialog,
    Icon,
    WSelect,
    WInput,
    IconButton,
    WDialog,
    StandardButton,
    Loader,
    ConfirmDialog,
    SpeachHtmlTranslationDialog,
    WPdfViewerDialog
  }
})], SpeachManageTranslationsModal);
export default SpeachManageTranslationsModal;